import React from 'react';
import Icon, { IconName } from './Icon';
import Button, { ButtonProps } from './Button';
import { Paper } from './Paper';
import Stack, { contentStackSpacing } from './Stack';
import Text from './Text';
import { mainContentPadding } from './MainContentContainer';
import { useIsMobileLayout } from '../../hooks/useIsMobileLayout';

export type LargeAlertPaperOwnProps = {
    title: string;
    message: string;
    icon: IconName;
    actionItems?: ButtonProps[];
    testID?: string;
};

export type LargeAlertPaperProps = LargeAlertPaperOwnProps;

const LargeAlertPaper: React.FC<LargeAlertPaperProps> = (props) => {
    const isMobile = useIsMobileLayout();

    const renderInActionButtonContainer = (children: any) => {
        if (isMobile) {
            return (
                <Stack
                    vertical
                    space={contentStackSpacing}
                    justify="center"
                    fullWidth
                    align="center"
                    style={{ marginTop: 8 }}
                >
                    {children}
                </Stack>
            );
        } else {
            return (
                <Stack horizontal space={contentStackSpacing} justify="center" fullWidth align="center">
                    {children}
                </Stack>
            );
        }
    };

    return (
        <Paper
            style={{
                width: '100%',
                padding: mainContentPadding,
            }}
            testID={props.testID}
        >
            <Stack vertical justify="center" fullWidth align="center" space={contentStackSpacing}>
                <Icon colorVariant="Dark-Text" name={props.icon} size="large-alert-paper-icon" />
                <Text variant="h4">{props.title}</Text>
                <Text variant="h6">{props.message}</Text>
                {renderInActionButtonContainer(
                    <>
                        {props.actionItems?.map((actionItem, index) => (
                            <Button key={index} {...actionItem} />
                        ))}
                    </>,
                )}
            </Stack>
        </Paper>
    );
};

export default React.memo(LargeAlertPaper);
